<template>
	<ul class="passwordStrength">
		<li :class="{ isValid: contains_eight_characters }">{{ T("ticketing_password_chars") }}<i class="material-icons">check_circle</i></li>
		<li :class="{ isValid: contains_uppercase }">{{ T("ticketing_password_uppercase") }}<i class="material-icons">check_circle</i></li>
		<li :class="{ isValid: contains_special_character }">{{ T("ticketing_password_special_chars") }}<i class="material-icons">check_circle</i></li>
		<li :class="{ isValid: password_repeat_matches }">{{ T("ticketing_password_matching") }}<i class="material-icons">check_circle</i></li>
	</ul>
</template>

<script>
	import defaultMixin from "@/mixins/default";
	export default {
		name: "d21-password-strength",
		mixins: [defaultMixin],
		props: {
			password: String,
			password_repeat: String
		},
		methods: {},
		computed: {
			contains_eight_characters() {
				return this.password && this.password.length > 8;
			},
			contains_uppercase() {
				return /[A-Z]/.test(this.password);
			},
			contains_special_character() {
				const format = /[ !@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/;
				return format.test(this.password);
			},
			isValid() {
				return this.contains_eight_characters && this.contains_uppercase && this.contains_special_character && this.password_repeat_matches;
			},
			password_repeat_matches() {
				return this.password && this.password === this.password_repeat;
			}
		},
		watch: {
			isValid(newValue, oldValue) {
				this.$emit('isValid', newValue);
			}
		}
	}
</script>

<style lang="less">
	ul.passwordStrength {
		padding: 0;
		margin: 2px 10px;
		list-style: square inside;
		font-size: 1.05em;

		li {
			color: red;
			line-height: 30px;

			.material-icons {
				position: relative;
				top: 6px;
				margin-left: 8px;
				display: none;
			}

			&.isValid {
				color: green;

				.material-icons {
					display: inline-block;
				}
			}
		}
	}
</style>